
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    address: {
      type: String,
      required: true
    }
  }
})
